// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__37nv7","error":"Textarea_error__3Y9hg","readonly":"Textarea_readonly__cnQDx","disabled":"Textarea_disabled__sl10M"};